import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import AlertSaveButton from '../../../../../button/AlertSaveButton';
import Skeleton from '@mui/material/Skeleton';
import ButtonStartIcon from '../../../../../button/ButtonStartIcon';
import Button from '@mui/material/Button';
import { getElementChildrenById } from '../../../../../../services/curriculum/elements.service';
import Element from './Element';
import MenuElement from './MenuElement';
import MenuElementChildren from './MenuChildren';
import { useSelector } from 'react-redux';
import IconTooltipButton from '../../../../../button/IconTooltipButton';
import useCurriculumElementsStructure from '../../../../../../hooks/curriculum/useCurriculumElementsStructure';

const initialState = {
  mouseX: null,
  mouseY: null
}
const View = () => {
  const permission = useSelector((state) => state?.session?.permissions ? state?.session?.permissions['curriculum-elements'] || {} : {});
  const { isLoadingList } = useCurriculumElementsStructure()
  const elementsStructure = useSelector((state) => state?.curriculum?.elementsStructure || {});
  const navigate = useNavigate();
  const { curriculumId, elementId } = useParams();
  const [change, setChange] = useState(false);
  const [form, setForm] = useState({});
  const [isLoading, setIsLoadingList] = useState({});

  const [data, setData] = useState({});

  const [menuChildren, setMenuChildren] = useState(initialState);
  const [modalChildren, setModalChildren] = useState(null);

  const [menuElement, setMenuElement] = useState(initialState);
  const [modalElement, setModalElement] = useState(null);

  const handleMenuElementClose = () => setMenuElement(initialState)
  const handleMenuElementOpen = (event, data) => {
    setMenuElement({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4
    });
    setData(data)
  };

  const handleMenuChildrenClose = () => setMenuChildren(initialState)
  const handleMenuChildrenOpen = (event, data) => {
    setMenuChildren({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4
    });
    setData(data)
  };

  const fetchElement = useCallback(async () => {
    setIsLoadingList(true);
    try {
      const response = await getElementChildrenById(curriculumId, elementId);
      if (response.error || !response?.data) {
      } else {
        setForm(response?.data || {})
      }
    } catch (error) {
    } finally {
      setIsLoadingList(false);
    }
  }, [change]);

  const onCancel = () => {
    navigate(`/dashboard/curriculum/${curriculumId}/elements`)
  }

  useEffect(() => {
    fetchElement()
  }, [fetchElement])

  return <>
    <Box className='flex gap-2 items-center justify-between pl-2 pr-4 py-2 bg-background sticky z-10 left-0px top-10'>
      <div className='flex gap-2 items-center'>
        { isLoading
          ? 
          <>
            <Skeleton variant="circular" width='2.5rem' height='2.5rem' />
            <Typography variant='subtitle1'><Skeleton variant='text' width={300} /></Typography>
          </>
          : 
          <Button
            variant='text'
            size='small'
            onClick={() => setModalChildren({
              type: 'edit',
              form: {
                children: form
              }
            })}
            style={{
              color: form?.primaryColor ?? 'initial',
              padding: 0,
              paddingRight: '0.5rem'
            }}
            startIcon={<div
              className={[
                'size-10 flex items-center justify-center rounded-full',
                form?.icon?.length > 0 ? '' : ' border border-muted'
              ].join(' ')}
              style={{
                color: form?.secondaryColor ?? 'initial',
                backgroundColor: form?.primaryColor ?? 'inherit'
              
              }}
            >
              { form?.icon && <FontAwesomeIcon icon={form?.icon} className='px-2 text-lg text-primary-foreground' /> }
            </div>}
            className='initial-case px-4'
          >
            <Typography className='py-1 text-shadow-xs flex items-center'>
              {form?.name}
            </Typography>
          </Button>
        }
      </div>
      <div className='flex gap-4 items-center justify-end'>
        { permission.deleted &&
          <IconTooltipButton
            id={`delete-${curriculumId}`}
            disabled={isLoading}
            title='Delete'
            icon='trash-alt'
            style={{
              borderRadius: '0.5rem',
              backgroundColor: '#fff',
              color: 'var(--destructive)',
              padding: '0.45rem',
            }}
            className="shadow-sm"
            onClick={() => setModalChildren({
              type: 'delete',
              form: {
                children: form
              }
            })}
          />
        }
        <div />
        { permission.updated && elementsStructure?.children?.length > 0 &&
          <ButtonStartIcon 
            startIcon='plus'
            color='primary'
            variant='contained'
            onClick={() => setModalElement({
              type: 'create',
              form: {}
            })}
          >
            Add
          </ButtonStartIcon>
        }
        <AlertSaveButton
          submodule='Curriculum element'
          disabled={isLoading}
          icon={['fal', 'times']}
          title='Cancel'
          color='primary'
          variant='outlined'
          className='shadow-sm'
          onDontSave={onCancel}
        />
      </div>
    </Box>
    <Box className='absolute'>
      <Box className='pr-4 overflow-auto'>
        <div className='flex flex-col w-full border-y border-muted'>
          { form?.elements?.map((element, index) => {
            const elementData = elementsStructure.children.find((el) => String(el._id) === String(element.elementStructureId));
        
            return (
              <Element
                index={index}
                id={`${elementId}-element-${element._id}-${index}`}
                key={`${elementId}-element-${element._id}-${index}`}
                element={element}
                elementData={elementData}
                onSettingElement={handleMenuElementOpen}
                onSettingChildren={handleMenuChildrenOpen}
                parent={{
                  _id: elementData._id,
                  name: elementData.name
                }}
                parentElements={{
                  _id: elementData._id,
                  name: elementData.name
                }}
                parentChildrenn={{
                  _id: elementData._id,
                  name: elementData.name
                }}
              />
            );
          })}
        </div>
      </Box>
    </Box>
    <MenuElementChildren
      baseElement={form}
      setChange={setChange}

      data={data}
      setData={setData}

      menuChildren={menuChildren}
      handleMenuChildrenClose={handleMenuChildrenClose}
      modalChildren={modalChildren}
      setModalChildren={setModalChildren}
      setModalElement={setModalElement}
    />
    <MenuElement
      baseElement={form}
      setChange={setChange}

      data={data}
      setData={setData}
      menuElement={menuElement}
      handleMenuElementClose={handleMenuElementClose}
      modalElement={modalElement}
      setModalElement={setModalElement}
      setModalChildren={setModalChildren}
    />
  </>;
}

export default View